import {
  AutocompleteInput,
  BooleanInput,
  DateInput,
  ReferenceInput,
  SearchInput,
  SelectInput,
  TextInput,
} from "react-admin";

const makeFilters = (role) => {
  const filters = [
    // #61 - free-text search: partial match on the request's agent identity
    // fields (name, email, NPN, phone).
    <SearchInput source="q" placeholder="Name, email, NPN, or phone" alwaysOn />,
    <ReferenceInput source="contracts.carrier" reference="carrier">
      <SelectInput fullwidth="true" optionText="value" />
    </ReferenceInput>,
    <ReferenceInput source="specialist" label="ACE" reference="user">
      <AutocompleteInput fullwidth />
    </ReferenceInput>,
    <TextInput source="npn" label="NPN" />,
    <TextInput source="name" label="Name" />,
    <TextInput source="email" label="Email" />,
    <TextInput source="phone" label="Phone" />,
    <DateInput source="createdAt!GTE" label="After" />,
    <DateInput source="createdAt!LTE" label="Before" />,
    <BooleanInput source="unknownAgent" label="Unknown Agent" />,
  ];
  if (role === "admin") {
    filters.push(<BooleanInput source="userStates" label="My States" />);
    filters.push(<ReferenceInput source="agency" label="Agency" reference="agency">
                    <SelectInput fullwidth="true" label="Agency" />
                 </ReferenceInput>);
  }
  return filters;
};

export default makeFilters;
